import { render, staticRenderFns } from "./AccountData.vue?vue&type=template&id=ef45580a&"
import script from "./AccountData.vue?vue&type=script&lang=js&"
export * from "./AccountData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports